// extracted by mini-css-extract-plugin
export default {"container":"bxaXeQjHrEN4qViuIYE5","slider":"u47e6iZfCEFoaACrMqAI"};